import { render } from "./ChartDataLabels.vue?vue&type=template&id=3b33a165&scoped=true"
import script from "./ChartDataLabels.vue?vue&type=script&lang=js"
export * from "./ChartDataLabels.vue?vue&type=script&lang=js"

import "./ChartDataLabels.vue?vue&type=style&index=0&id=3b33a165&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b33a165"]])

export default __exports__